export default __webpack_public_path__ + "static/media/news90.e87efda8.jpg";